import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const EmptyDocumentIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M6.28571 22.2857H17.7143C18.3205 22.2857 18.9019 22.0449 19.3305 21.6162C19.7592 21.1876 20 20.6062 20 20V9.04456C19.9999 8.74148 19.8795 8.45084 19.6651 8.23656L13.4777 2.04914C13.2634 1.83479 12.9728 1.71434 12.6697 1.71428H6.28571C5.67951 1.71428 5.09812 1.95509 4.66947 2.38375C4.24082 2.8124 4 3.39378 4 3.99999V20C4 20.6062 4.24082 21.1876 4.66947 21.6162C5.09812 22.0449 5.67951 22.2857 6.28571 22.2857Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

EmptyDocumentIcon.displayName = 'EmptyDocumentIcon';
